import axios from "axios";
import JwtService from "@/core/services/jwt.service";

/**
 * Service to call HTTP request via Axios
 */
const ApiService = {
  init(app) {
    axios.defaults.baseURL = process.env.VUE_APP_API_URL;

    app.config.globalProperties.$axios = axios;
  },

  /**
   * Set the default HTTP request headers
   */
  setHeader(panel = "employer") {
    if (panel === "employer") {
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${JwtService.getToken()}`;
    } else if (panel === "jobseeker") {
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${JwtService.getJobseekerToken()}`;
      axios.defaults.headers.common["jobseeker"] = true;
    }
  },

  query(resource, params) {
    return axios.get(resource, { params }).catch((error) => {
      throw new Error(`[KT] ApiService ${error}`);
    });
  },

  get(resource, params = {}) {
    return axios.get(resource, { params });
  },

  post(resource, params) {
    return axios.post(resource, params);
  },

  update(resource, slug, params) {
    return axios.put(`${resource}/${slug}`, params);
  },

  put(resource, params) {
    return axios.put(resource, params);
  },

  patch(resource, params) {
    return axios.patch(resource, params);
  },

  delete(resource, params) {
    return axios.delete(resource, { data: params }).catch((error) => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },
};

export default ApiService;
